import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import {
    isExperimentalSelector,
    isMaintenanceFlagSelector,
} from './common/selectors/ui-state-selectors';
import EfdPrivateRoutesContainer from './efd-private-routes-container';
import IdmVerifyContainer from './common/containers/idm-verify-container';
import LoginContainer from './common/containers/login-container';
import MaintenancePage from './common/components/maintenance-page';
import ProofpointLoadingBar from './common/components/proofpoint-loading-bar';

class EfdRoutes extends Component{
    render(){
        const {
            createSessionInFlight,
            isInitialLoad,
            isSessionValid,
            maintenanceFlag
        } = this.props;
        return (
            <Switch>
                <Route
                    component={MaintenancePage}
                    exact
                    path="/maintenance"
                    {...this.props}
                />
                {maintenanceFlag && <Redirect from="/" to="/maintenance" /> }
                <Route
                    component={IdmVerifyContainer}
                    exact
                    path="/verify"
                    {...this.props}
                />
                {
                    ( isInitialLoad || createSessionInFlight ) && <ProofpointLoadingBar />
                }
                {
                    isSessionValid && <EfdPrivateRoutesContainer/>
                }
                <Route component={LoginContainer}/>
            </Switch>
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isExperimental: isExperimentalSelector( state ),
        maintenanceFlag: isMaintenanceFlagSelector( state ),
    };
};

EfdRoutes.propTypes = {
    createSessionInFlight: PropTypes.bool,
    isInitialLoad: PropTypes.bool,
    isSessionValid: PropTypes.bool,
    maintenanceFlag: PropTypes.bool,
};

export default connect( mapStateToProps )( EfdRoutes );
